// app/client-layout.tsx
"use client";

import { ReactNode, Suspense, useState } from "react";
import { ClientWalletProvider } from "@/components/ClientWalletProvider";
import Navbar from "@/components/Navbar";
import { StatusBar } from "@/components/StatusBar";
import { DataProvider } from "@/contexts/DataContext";
import { SessionProvider } from "next-auth/react";
import { PasskeyProvider } from "@/contexts/PasskeyContext";

const SHOW_PREVIEW_BANNER = process.env.NEXT_PUBLIC_PREVIEW_BANNER !== "false";

interface ClientLayoutProps {
  children: ReactNode;
}

function PreviewBanner({ onDismiss }: { onDismiss: () => void }) {
  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] h-[30px] flex items-center justify-center gap-2 px-4 text-[11px] font-medium tracking-wide bg-[#111111] text-[#999999] border-b border-[var(--border-subtle)]">
      <span className="truncate">PREVIEW — Pre-release deployment. Data and functionality may be limited.</span>
      <button
        onClick={onDismiss}
        aria-label="Dismiss preview banner"
        className="opacity-60 hover:opacity-100 text-base leading-none px-1 cursor-pointer bg-transparent border-none text-[#999999]"
      >
        ×
      </button>
    </div>
  );
}

export function ClientLayout({ children }: ClientLayoutProps) {
  const [bannerVisible, setBannerVisible] = useState(SHOW_PREVIEW_BANNER);

  return (
    <SessionProvider>
      <PasskeyProvider>
      <ClientWalletProvider>
        <Suspense fallback={<div className="min-h-screen" />}>
          <DataProvider>
            {bannerVisible && (
              <>
                <PreviewBanner onDismiss={() => { setBannerVisible(false); }} />
                <style>{`#navbar-shell { top: 30px !important; }`}</style>
              </>
            )}
            <Navbar />
            <main className="flex-1">{children}</main>
            <StatusBar />
          </DataProvider>
        </Suspense>
      </ClientWalletProvider>
      </PasskeyProvider>
    </SessionProvider>
  );
}
